<template>
  <div class="bj-warp">
    <div class="top-nav-menu">
      <img class="banner" src="@/assets/image/banner.png" alt="" srcset="" />
      <slot name="search"></slot>
      <div class="top-nav-menu-box" :style="headStyle">
        <a class="logo" href="/index">
          <img class="login-name" src="@/assets/image/logo.png" alt="" />
        </a>
        <div class="nav-list" style="height: 60px; line-height: 60px">
          <template v-for="item in menuList">
            <router-link
              v-if="item.target === 'self'"
              :class="['menu-item']"
              :key="item.name"
              :to="item.path"
              >{{ item.name }}</router-link
            >
            <a
              class="menu-item"
              v-else-if="item.target === 'blank'"
              :href="item.path"
              target="_blank"
              :key="item.name"
              >{{ item.name }}</a
            >
          </template>
        </div>
        <div class="nav-box-right">
          <router-link class="r-link" to="/whoisSearch">Whois查询</router-link>
          <router-link class="r-link nav-cart" to="/cart">
            <span>购物车</span>
            <div v-if='user.shoppingCartCount > 0' class="cart-number">{{ user.shoppingCartCount > 99 ? '99+' : user.shoppingCartCount  }}</div>
          </router-link>
          <router-link class="mail-box" to="/my/user/mail">
            <img class="mail-img" src="@/assets/image/mail.png" alt="">
            <div v-if='user.siteCount > 0' class="mail-num">{{ user.siteCount > 99 ? '99+' : user.siteCount  }}</div>
          </router-link>
          <template v-if="!token">
            <router-link class="r-link" to="/login">登录</router-link>
            <router-link class="r-link r-reg" to="/sige">免费注册</router-link>
          </template>
          <template v-else>
            <div class="user-info flex-content">
              <img
                class="u-icon"
                src="@/assets/image/index-icon.png"
                alt="icon"
                srcset=""
              />
              <div class="name">{{ user.nick || user.mobile }}</div>
              <ul class="u-dropdown-menu">
                <li>
                  <router-link style="color: #ff5c35" to="/my"
                    >我的主页</router-link
                  >
                </li>
                <li>
                  <span class="u-label">账户余额：</span
                  ><span class="price">{{ balance }}</span>
                </li>
                <li>
                  <span class="u-label">冻结余额：</span
                  ><span class="price">{{ freezeAmount }}</span>
                </li>
                <li class="logout">
                  <Button
                    style="background-color: #ff5c35; border-color: #ff5c35"
                    type="primary"
                    @click="evt_logout"
                    >退出</Button
                  >
                </li>
              </ul>
            </div>
          </template>
        </div>
      </div>
    </div>
    <slot></slot>
    <div class="foot-nav">
      <div class="foot-nav-warp">
        <a
          class="link"
          v-for="item in navList"
          :href="item.path"
          target="_blank"
          :key="item.name"
          >{{ item.name }}</a
        >
      </div>
    </div>
    <div class="foot-bar">
      <div class="foot-bar-warp">
        <div class="foot-section1">
          <div class="foot-section-text">
            域见未来（北京）科技有限公司
             <a style="color: #737577" target="_blank" href="http://beian.miit.gov.cn">京ICP备2020035975号</a>
          </div>
          <div class="foot-section-text">
            北京市 海淀区 白家疃尚水园 4号楼 8层 3单元 801
          </div>
          <div class="foot-section-text">
            域名投诉举报处理平台 电话:010-58813000 邮箱:service@cnnic.cn
          </div>
        </div>
        <div class="foot-section2">
          <div class="foot-section-text">客服、投诉电话： 400-076-3676</div>
          <div class="foot-section-text">客服、投诉邮箱： service@domainfuture.cn</div>
        </div>
        <div class="foot-section3">
          <div class="foot-section-text">
            互联网域名服务许可证:
            <a style="color: #737577" target="_blank" href="https://domain.miit.gov.cn/域名注册服务机构/互联网域名/域见未来（北京）科技有限公司">京D3-20220005</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "layout",
  data() {
    return {
      menuList: [
        {
          name: "域名注册",
          path: "/index",
          target: "self",
        },
        {
          name: "关于我们",
          path: "http://www.domainfuture.cn/about_complex.aspx?nid=1",
          target: "blank",
        },
        {
          name: "联系我们",
          path: "http://www.domainfuture.cn/contact_complex.aspx?nid=7",
          target: "blank",
        },
      ],
      navList: [
        {
          name: "关于我们",
          path: "http://www.domainfuture.cn/about_complex.aspx?nid=1",
          target: "blank",
        },
        {
          name: "联系我们",
          path: "http://www.domainfuture.cn/contact_complex.aspx?nid=7",
          target: "blank",
        },
      ],
      headStyle: {
        background: "rgba(0, 0, 0, 0)",
      },
      value: "",
    };
  },
  computed: {
    ...mapState(["user", "token", "freezeAmount", "balance"]),
  },
  mounted() {
    window.addEventListener("scroll", this.scroll);
  },
  methods: {
    ...mapMutations(["MUT_TOKEN_INFO"]),
    scroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop == 0) {
        this.headStyle.background = "rgba(0, 0, 0, 0)";
      } else {
        this.headStyle.background = "rgba(33, 34, 37, 1)";
      }
    },
    evt_logout() {
      this.MUT_TOKEN_INFO({});
      window.location.reload();
      localStorage.removeItem("vuex");
    },
  },
};
</script>
<style lang="less" scoped>
.bj-warp {
  position: relative;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  min-height: 100vh;
  .menu-item {
    color: #fff;
    line-height: 60px;
    font-weight: 400;
    font-size: 14px;
    margin-right: 40px;
  }
}
.foot-nav {
  display: flex;
  align-items: center;
  background-color: #212225;
  height: 80px;
  .foot-nav-warp {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    //justify-content: space-between;
    .link {
      width: 120px;
      height: 45px;
      line-height: 45px;
      border-radius: 23px;
      text-align: center;
      font-size: 14px;
      color: #737577;
      font-weight: 400;
    }
    .link.active {
      color: #f85936;
    }
  }
}
.foot-bar {
  background-color: #212225;
  border-top: 1px solid #ffffff1a;
  .foot-bar-warp {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    padding-top: 45px;
    padding-bottom: 36px;
    .foot-section-text {
      font-weight: 400;
      font-size: 14px;
      color: #737577;
      &:nth-child(n + 2) {
        margin-top: 15px;
      }
    }
    .foot-section2 {
      margin-left: 116px;
    }
    .foot-section3 {
      flex: 1;
      display: flex;
      justify-content: space-between;
      margin-left: 136px;
      .customer {
        margin-top: 21px;
        width: 110px;
        text-align: center;
        height: 35px;
        line-height: 35px;
        color: #fff;
        border: 1px solid #f85a36;
        cursor: pointer;
        background-color: #f85a36;
        border-radius: 46px;
      }
    }
  }
}
.nav-list {
  position: relative;
  width: 1200px;
  margin: 0 auto;
}
.top-nav-menu {
  font-size: 0;
  position: relative;
  transition: all 0.3s;
  .banner {
    width: 100%;
    min-height: 320px;
    line-height: 320px;
  }
  .top-nav-menu-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
  }
  .logo {
    position: absolute;
    left: 60px;
    font-size: 0;
    top: 10px;
    .login-name {
      height: 40px;
    }
  }
  .nav-box-right {
    position: absolute;
    top: 10px;
    right: 70px;
    align-self: center;
    height: 40px;
    display: flex;
    margin-right: 20px;
     .nav-cart{
      position: relative;
      .cart-number{
        box-sizing: border-box;
        min-width: 18px;
        padding:0 5px;
        height: 18px;
        border-radius: 9px;
        color: #fff;
        font-size: 12px;
        background: #F9521f;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top:0px;
        right: 5px;
      }
    }
    .mail-box{
      position: relative;
      width: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      .mail-img{
        width: 22px;
        height: 22px;
      }
      .mail-num{
        box-sizing: border-box;
        min-width: 18px;
        padding:0 5px;
        height: 18px;
        border-radius: 9px;
        color: #fff;
        font-size: 12px;
        background: #F9521f;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top:0px;
        right: -8px;
      }
    }
    .r-link {
      display: inline-block;
      color: #fff;
      line-height: 40px;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      width: 80px;
    }
    .r-reg {
      width: 120px;
    }
    .user-info:hover .u-dropdown-menu {
      display: block;
    }
    .user-info {
      position: relative;
      .u-icon {
        width: 20px;
        height: 20px;
      }

      .name {
        position: relative;
        padding: 0 20px 0 15px;
        color: #fff;
        font-size: 14px;
        font-weight: 400;
        max-width: 120px;
        text-overflow: ellipsis;
        overflow: hidden;
        cursor: pointer;
        &::after {
          content: "";
          display: inline-block;
          border: 7px solid;
          border-color: #3773f5 transparent transparent transparent;
          vertical-align: middle;
          position: absolute;
          right: 0;
          top: 5px;
        }
      }

      .u-dropdown-menu {
        display: none;
        position: absolute;
        top: 100%;
        right: 0;
        z-index: 1000;
        min-width: 160px;
        padding: 5px 10px;
        list-style: none;
        font-size: 14px;
        text-align: left;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.18);
        background-clip: padding-box;
        li {
          line-height: 30px;
          display: flex;
          overflow: hidden;
          text-overflow: ellipsis;
          .u-label {
            flex: 0 0 70px;
          }
          .price {
            &::before {
              content: "¥";
              margin-right: 2px;
            }
            color: #ff5c35;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        .logout {
          margin-top: 10px;
        }
      }
    }
  }
}
.search-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -20%);
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  ::v-deep .search-input-warp {
    .ivu-input {
      height: 90px;
      line-height: 90px;
      font-size: 16px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .ivu-input:focus,
    .ivu-input:hover {
      box-shadow: none;
      border-color: #f85936;
    }
    .ivu-input-icon {
      font-size: 30px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .search-btn-warp {
    height: 90px;
    line-height: 90px;
    width: 190px;
    text-align: center;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #f85936;
    border-color: #f85936;
    font-size: 24px;
  }
}
</style>
